import styled from 'styled-components'
import * as Tabs from '@radix-ui/react-tabs'

export const TabsRoot = styled(Tabs.Root)``

export const TabsContent = styled(Tabs.Content)``

export const TabsTrigger = styled(Tabs.Trigger)``

export const TabsList = styled(Tabs.List)`
  display: flex;
  gap: 0.5rem;
`

export const PaginateControl = styled.div`
  display: flex;
  gap: 0.5rem;

  button {
    border: 0;
    background: var(--paginate-trigger-background);
    color: var(--paginate-trigger-color);

    font-size: 1rem;
    width: 2rem;
    height: 2rem;
    flex: 0 0 2rem;

    border-radius: 999px;
    border: var(--paginate-trigger-border);

    display: flex;
    align-items: center;
    justify-content: center;

    &[aria-selected='true'] {
      background: var(--paginate-trigger-selected-background);
      border: var(--paginate-trigger-selected-border);
      color: var(--paginate-trigger-selected-color);
    }

    &:disabled {
      background: var(--paginate-trigger-disabled-background);
      border: var(--paginate-trigger-disabled-border);
      color: var(--paginate-trigger-disabled-color);
    }
  }
`
